import { cls } from "@wss/cls";
import React from "react";
import Stars from "~/common/Stars";
interface ReviewsLinkProps {
  numberOfReviews: number;
  rating: number;
  minimalPageVersion?: boolean;
  itemNumber: string;
}
const reviewButtonText = (numberOfReviews: number) => {
  if (!numberOfReviews) {
    return "Leave a review";
  }
  return numberOfReviews > 1 ? `${numberOfReviews} reviews` : `${numberOfReviews} review`;
};
const ReviewsLink = ({
  numberOfReviews,
  rating,
  minimalPageVersion,
  itemNumber
}: ReviewsLinkProps) => {
  const handleReviewsLinkClick = () => {
    if (minimalPageVersion) {
      window.location.href = `/product-reviews/${itemNumber}.html`;
      return;
    }
    const elementToJumpTo = numberOfReviews ? document?.getElementById("reviews") : document?.getElementById("writeAReview");
    elementToJumpTo?.focus();
    elementToJumpTo?.scrollIntoView();
  };
  const smallMobileLinkText = reviewButtonText(numberOfReviews);
  const reviewslinkText = numberOfReviews > 0 ? `Read ${smallMobileLinkText}` : smallMobileLinkText;
  return <div data-sentry-component="ReviewsLink" data-sentry-source-file="ReviewsLink.tsx">
      <button type="button" onClick={handleReviewsLinkClick} className="flex items-center border-0 text-green-500 hover:text-green-700 p-0 bg-transparent" style={{
      fontFamily: "inherit"
    }}>
        <Stars rating={rating} data-sentry-element="Stars" data-sentry-source-file="ReviewsLink.tsx" />
        <span className={cls("product-subhead__rating-link mr-2 lt:mr-2.5 mt-0.5 lt:mt-0 hidden xxxs:inline", rating ? "ml-1" : "lt:ml-1")}>
          {reviewslinkText}
        </span>
        <span className={cls("product-subhead__rating-link mr-2 lt:mr-2.5 mt-0.5 lt:mt-0 xxxs:hidden", rating ? "ml-1" : "lt:ml-1")}>
          {smallMobileLinkText}
        </span>
      </button>
    </div>;
};
export default ReviewsLink;